import { render } from "./AddOperatingHoursModal.vue?vue&type=template&id=2a879c10&scoped=true&ts=true"
import script from "./AddOperatingHoursModal.vue?vue&type=script&lang=ts"
export * from "./AddOperatingHoursModal.vue?vue&type=script&lang=ts"

import "./AddOperatingHoursModal.vue?vue&type=style&index=0&id=2a879c10&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a879c10"]])

export default __exports__